// extracted by mini-css-extract-plugin
export var title = "anazitisi-module--title--mn6yF";
export var subheaderContainer = "anazitisi-module--subheader-container--1SHD2";
export var control = "anazitisi-module--control--SIQ-B";
export var loaderContainer = "anazitisi-module--loaderContainer--2rF38";